<template>
    <div class="rating__swiper_list">
        <swiper
            :slidesPerView="'auto'"
            :spaceBetween="30"
            :centeredSlides="true"
            :mousewheel="{
                forceToAxis: true,
            }"
            :modules="modules"
            @swiper="swiper"
            class="mySwiper"
            @slideChange="onSlideChange"
        >
            <span class="Irating"><IRating /></span>
            <swiper-slide
                @click="goToSlide(slide)"
                v-for="slide in 10"
                :key="slide"
                >{{ slide }}</swiper-slide
            >
        </swiper>
    </div>
</template>
<script>
import { Swiper, SwiperSlide } from "swiper/vue";
import { Mousewheel } from "swiper/modules";

import IRating from "./IRating.vue";
import "swiper/css";

export default {
    components: {
        Swiper,
        SwiperSlide,
        IRating,
    },
    emits: ["setRating"],
    props: ["customer_rating"],
    data() {
        return {
            swiperInstance: null,
        };
    },
    methods: {
        swiper(swiper) {
            this.swiperInstance = swiper;
            this.goToSlide(this.customer_rating);
        },
        onSlideChange(value) {
            this.$emit("setRating", value.activeIndex + 1);
        },
        goToSlide(value) {
            this.swiperInstance.slideTo(value - 1);
        },
    },
    mounted() {
        if (window.innerWidth < 992) {
            this.onSlideChange({ activeIndex: 0 });
        }
    },
    setup() {
        return {
            modules: [Mousewheel],
        };
    },
};
</script>

<style lang="scss">
.rating__swiper_list {
    .swiper {
        width: 100%;
        height: 100%;
        padding: 15px 0;
        position: relative;
        .Irating {
            content: "";
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            svg {
                width: 90px;
                height: 90px;
                color: #fff;
            }
        }
        &-wrapper {
            mix-blend-mode: difference;
        }
    }

    .swiper-slide {
        text-align: center;
        font-size: 40px;
        width: 60px;
        height: 60px;
        display: flex;
        justify-content: center;
        align-items: center;
        color: white; /* Изначальный цвет текста */
        mix-blend-mode: difference;
        user-select: none;
    }
}
</style>
